import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Rocket, Sparkles, globe, Lock, CheckCircle2 } from 'lucide-react';

const PublishRecipeDialog = ({ show, onHide, onConfirm, recipeTitle }) => {
    const [consent, setConsent] = React.useState(false);

    // Reset consent when dialog opens/closes (optional, but good practice)
    React.useEffect(() => {
        if (show) setConsent(false);
    }, [show]);

    const handleConfirm = () => {
        if (!consent) {
            alert("Bitte bestätige den Urheberrechtshinweis.");
            return;
        }
        onConfirm();
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            dialogClassName="modal-90w"
            contentClassName="rounded-5 border-0 overflow-hidden"
        >
            <div className="position-relative bg-primary bg-gradient p-5 text-center text-white overflow-hidden">
                {/* Background Decor */}
                <div className="position-absolute top-0 start-0 w-100 h-100 opacity-25" style={{
                    backgroundImage: 'radial-gradient(circle at center, white 2px, transparent 10px)',
                    backgroundSize: '30px 30px'
                }}></div>
                <div className="position-absolute top-0 end-0 p-4 opacity-50">
                    <Sparkles size={80} />
                </div>

                <div className="position-relative z-1">
                    <div className="bg-white rounded-circle d-inline-flex p-4 mb-4 shadow-lg animate-bounce-in">
                        <Rocket size={48} className="text-primary" fill="currentColor" />
                    </div>
                    <h2 className="display-6 fw-bold mb-3">Rezept veröffentlichen</h2>
                    <p className="lead opacity-90 mb-0" style={{ maxWidth: '400px', margin: '0 auto' }}>
                        Bist du bereit, <span className="fw-bold text-warning">"{recipeTitle}"</span> mit der Welt zu teilen?
                    </p>
                </div>
            </div>

            <div className="p-4 p-md-5 bg-white">
                <div className="row g-4 mb-5">
                    <div className="col-md-6">
                        <div className="d-flex gap-3">
                            <div className="flex-shrink-0 mt-1">
                                <div className="bg-success bg-opacity-10 p-2 rounded-circle">
                                    <CheckCircle2 size={24} className="text-success" />
                                </div>
                            </div>
                            <div>
                                <h6 className="fw-bold mb-1">Offizieller Release</h6>
                                <p className="text-muted small mb-0">Dein Rezept wird als final markiert und für andere sichtbar gemacht.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex gap-3">
                            <div className="flex-shrink-0 mt-1">
                                <div className="bg-warning bg-opacity-10 p-2 rounded-circle">
                                    <Lock size={24} className="text-warning" />
                                </div>
                            </div>
                            <div>
                                <h6 className="fw-bold mb-1">Inhaltsschutz</h6>
                                <p className="text-muted small mb-0">Um Konsistenz zu wahren, kann das Rezept nach der Veröffentlichung nicht mehr bearbeitet werden.</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Copyright Disclaimer */}
                <div className="bg-light bg-opacity-50 p-3 rounded-4 border border-light mb-4">
                    <div className="form-check">
                        <input
                            className="form-check-input mt-1"
                            type="checkbox"
                            id="publish-consent"
                            checked={consent}
                            onChange={(e) => setConsent(e.target.checked)}
                        />
                        <label className="form-check-label ps-2" htmlFor="publish-consent">
                            <span className="fw-bold d-block text-dark">Urheberrechtshinweis</span>
                            <span className="text-muted small">
                                Ich bestätige, dass ich das Recht habe, dieses Rezept und die Bilder zu veröffentlichen
                                und dass keine Urheberrechte Dritter verletzt werden.
                            </span>
                        </label>
                    </div>
                </div>

                <div className="d-flex justify-content-center gap-3">
                    <Button
                        variant="light"
                        size="lg"
                        className="rounded-pill px-4 border"
                        onClick={onHide}
                    >
                        Noch nicht
                    </Button>
                    <Button
                        variant="primary"
                        size="lg"
                        className="rounded-pill px-5 shadow fw-bold d-flex align-items-center gap-2 hover-scale"
                        onClick={handleConfirm}
                        disabled={!consent}
                    >
                        <Rocket size={20} />
                        Jetzt veröffentlichen
                    </Button>
                </div>
            </div>

            <style>{`
                .animate-bounce-in {
                    animation: bounceIn 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
                }
                @keyframes bounceIn {
                    0% { transform: scale(0); opacity: 0; }
                    60% { transform: scale(1.1); opacity: 1; }
                    100% { transform: scale(1); }
                }
                .hover-scale { transition: transform 0.2s; }
                .hover-scale:hover { transform: translateY(-2px); }
            `}</style>
        </Modal>
    );
};

export default PublishRecipeDialog;
